import { render, staticRenderFns } from "./PagePicker.vue?vue&type=template&id=27625748&scoped=true&"
import script from "./PagePicker.vue?vue&type=script&lang=ts&"
export * from "./PagePicker.vue?vue&type=script&lang=ts&"
import style0 from "./PagePicker.vue?vue&type=style&index=0&id=27625748&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27625748",
  null
  
)

export default component.exports